export default {
  'userInvite.title': 'Kullanıcı Davet Et',
  'userInvite.email': 'Eposta',
  'userInvite.selectGroup': 'Kullanıcı Grubu',
  'userInvite.select': 'Seçiniz',
  'userInvite.emailHing': 'john.doe@example.com',
  'userInvite.emailHint': 'Harf, sayı ve nokta kullanabilirsiniz',
  'userInvite.success': 'Kullanıcı başarıyla davet edildi!',
};
